export default (controller, stateManager, internalStateSetter) => {
    return (eventName, bindings) => {
        if (!controller[eventName] || typeof controller[eventName] != 'function') {
            throw `function ${eventName} does not exist or is not a function`
        }
        return controller[eventName](bindings, stateManager, internalStateSetter)
    }
}